import { call, put } from "@redux-saga/core/effects";
import { driverLogApi } from "../../../Connections/APIs/DriverLog";
import { getDriverLogFailAction, getDriverLogSuccessAction } from "../../Actions/DriverLog/Action";

export function* getDriverLogSaga(action) {
    try {
      const response = yield call(driverLogApi, action.data);
      yield put(getDriverLogSuccessAction(response.data));
    } catch (error) {
      yield put(getDriverLogFailAction(error));
    }
  }